import { CommonActivityType } from './common-activity-type.enum';

/**
 * Activity types tracked in the vendor_activity table (DD.11.3).
 *
 * Mirrors `ClientActivityType` for symmetry — many vendor
 * interactions (calls, notes, contacts, addresses) parallel client
 * ones, and reps benefit from a consistent activity-feed shape
 * regardless of which entity they're looking at. Vendor-specific
 * additions (e.g. PO-related events) can be added here as the
 * vendor surface grows.
 */
export const VendorActivityType = {
	...CommonActivityType,

	// Contact management
	CONTACT_ADDED: 'contact_added',
	CONTACT_UPDATED: 'contact_updated',
	CONTACT_DELETED: 'contact_deleted',

	// Address management
	ADDRESS_ADDED: 'address_added',
	ADDRESS_UPDATED: 'address_updated',
	ADDRESS_DELETED: 'address_deleted',

	// Call logs (from vendor interface — DD.11.4 wires these)
	CALL_LOGGED: 'call_logged',
	CALL_UPDATED: 'call_updated',
	CALL_DELETED: 'call_deleted',

	// Vendor operations
	VENDOR_MERGED: 'vendor_merged',

	// Watcher management
	WATCHER_ADDED: 'watcher_added',
	WATCHER_REMOVED: 'watcher_removed',

	// Transaction references — purchase-order-side analogues of the
	// client sales-order events
	PURCHASE_ORDER_CREATED: 'purchase_order_created',
	PURCHASE_ORDER_SUBMITTED: 'purchase_order_submitted',
	PURCHASE_ORDER_APPROVED: 'purchase_order_approved',
	PURCHASE_ORDER_CANCELLED: 'purchase_order_cancelled',
	PURCHASE_ORDER_RECEIVED: 'purchase_order_received',

	// AI interactions
	AI_CALL: 'ai_call',
} as const;

export type VendorActivityType =
	(typeof VendorActivityType)[keyof typeof VendorActivityType];
